import { render, staticRenderFns } from "./PemotonganRekap.vue?vue&type=template&id=610ef088&scoped=true&"
import script from "./PemotonganRekap.vue?vue&type=script&lang=js&"
export * from "./PemotonganRekap.vue?vue&type=script&lang=js&"
import style0 from "./PemotonganRekap.vue?vue&type=style&index=0&id=610ef088&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610ef088",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VProgressLinear,VRow,VSelect,VTextField})
